import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { NavBar } from './NavBar';
import { HERO, HERO_METRICS, OFFER_ANCHOR, PRICE, STUFFED_IMAGE } from './salesData';
import { HERO_IMAGE_URL } from '../utils/headMeta';

/**
 * Hero mobile-first. La protagonista visual es la cookie abierta: el RESULTADO.
 * Los dos tomos aparecen como mecanismo, en segundo plano.
 * El CTA NO abre el checkout: hace smooth-scroll a la sección de oferta.
 */
export function Hero() {
  return <div id="top" className="relative overflow-hidden bg-ivory" data-id="element-221" data-mp="x9urxqjzk6af">
      <NavBar data-id="element-222" data-mp="x8jndoipuui9" />

      <section aria-labelledby="hero-title" className="relative mx-auto w-full max-w-6xl px-5 pb-8 pt-5 sm:px-8 lg:grid lg:grid-cols-[1.02fr_0.98fr] lg:items-center lg:gap-x-12 lg:py-14" data-id="element-223" data-mp="sb1axo5hpx5i">
        {/* Promesa */}
        <div className="animate-hero-copy" data-id="element-224" data-mp="3d21tk0zn2qpb">
          <p className="inline-flex items-center gap-2 rounded-full bg-bone px-3 py-1.5 font-sans text-[0.54rem] font-bold uppercase tracking-editorial text-charcoal sm:text-[0.62rem]" data-id="element-225" data-mp="3d2torapbqmf2">
            <span className="h-1.5 w-1.5 rounded-full bg-caramel" aria-hidden data-id="element-226" data-mp="3j9tymsm91cin" />
            {HERO.eyebrow}
          </p>

          <h1 id="hero-title" className="mt-3 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.9rem] sm:leading-[1.03] lg:text-[3.3rem]" data-id="element-227" data-mp="3o5j4tesrxrnx">
            {HERO.title}{' '}
            <span className="text-[#F47A2A]" data-id="element-228" data-mp="3e7uzjuxjl1ri">{HERO.titleAccent}</span>
          </h1>

          <p className="mt-3.5 max-w-xl font-sans text-[0.92rem] leading-relaxed text-charcoal-mid sm:text-[1.02rem]" data-id="element-229" data-mp="30h9crv4yw7oc">
            {HERO.subtitle}
          </p>
        </div>

        {/* Dos bloques visuales diferenciados, nunca superpuestos:
            1) EL RESULTADO — la fotografía de la cookie abierta.
            2) EL PRODUCTO — el mockup principal de los 2 tomos + cookies. */}
        <div className="animate-hero-media mt-7 lg:col-start-2 lg:row-span-3 lg:row-start-1 lg:mt-0 lg:self-center" data-id="element-230" data-mp="2hk8685vrlzia">
          <figure data-id="element-231" data-mp="2lk8usjckvr32">
            
            
          </figure>

          <figure className="relative mt-7" data-id="element-232" data-mp="s2jj7lrcvge8">
            <div className="absolute left-1/2 top-1/2 h-[80%] w-[88%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold-pale/70 blur-2xl" aria-hidden data-id="element-233" data-mp="s3cloaja7jqk" />
            <div className="mockup-ground absolute bottom-3 left-1/2 h-8 w-[70%] -translate-x-1/2 blur-md sm:h-11" aria-hidden data-id="element-234" data-mp="ibgnkzh73tmc" />
            <img src={HERO_IMAGE_URL} alt="Los 2 tomos de 100 New York Cookies rodeados de cookies rellenas de chocolate, dulce de leche, pistacho, red velvet y cookies & cream." loading="lazy" decoding="async" className="animate-breathe relative mx-auto w-full max-w-[21rem] object-contain drop-shadow-[0_26px_42px_rgba(51,39,34,0.24)] sm:max-w-[26rem] lg:max-w-none" data-id="element-235" data-mp="deq8ofh4n42i" />
            <figcaption className="mt-1 text-center font-sans text-[0.58rem] font-bold uppercase tracking-editorial text-[#F47A2A] sm:text-[0.62rem]" data-id="element-236" data-mp="x1w7maxvkvix">
              Lo que recibís · 2 tomos digitales
            </figcaption>
          </figure>
        </div>

        {/* Precio + CTA + confianza */}
        <div className="mt-9 lg:col-start-1 lg:row-start-2 lg:mt-7" data-id="element-237" data-mp="1xa431cdmkgik">
          <p className="font-sans text-[0.86rem] font-bold leading-snug text-charcoal sm:text-[0.94rem]" data-id="element-238" data-mp="21awe8b624vhh">
            {HERO.note}
          </p>

          

          <a href={OFFER_ANCHOR} className="group mt-4 flex min-h-[58px] w-full items-center justify-center gap-2.5 rounded-full bg-[#F47A2A] px-6 py-3.5 text-center font-sans text-[0.8rem] font-bold uppercase leading-tight tracking-[0.07em] text-white shadow-[0_16px_30px_-12px_rgba(244,122,42,0.55)] transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:bg-[#DF6A1D] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#F47A2A]/50 sm:text-[0.9rem] lg:w-auto lg:px-10" data-id="element-239" data-mp="268g3050dsqno">
            {HERO.cta}
            <span className="transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden data-id="element-240" data-mp="umpqo3f6hozj">
              →
            </span>
          </a>

          <ul className="mt-3.5 flex flex-wrap items-center gap-x-5 gap-y-2" data-id="element-241" data-mp="zlstdh7orj4c">
            <li className="flex items-center gap-1.5 font-sans text-[0.72rem] font-semibold text-charcoal-mid" data-id="element-242" data-mp="4a2xptbp3q3u">
              <LockIcon className="h-3.5 w-3.5 text-[#F47A2A]" aria-hidden data-id="element-243" data-mp="3vhfe464r7zip" /> Pago seguro
            </li>
            <li className="flex items-center gap-1.5 font-sans text-[0.72rem] font-semibold text-charcoal-mid" data-id="element-244" data-mp="e8sbb9wk6oea">
              <ZapIcon className="h-3.5 w-3.5 text-[#F47A2A]" aria-hidden data-id="element-245" data-mp="98mivrigsxv5" /> Acceso inmediato
            </li>
            <li className="flex items-center gap-1.5 font-sans text-[0.72rem] font-semibold text-charcoal-mid" data-id="element-246" data-mp="3cr7fo1c01x8u">
              <ShieldCheckIcon className="h-3.5 w-3.5 text-[#F47A2A]" aria-hidden data-id="element-247" data-mp="3rftv031mmp02" /> Garantía de 7
              días
            </li>
          </ul>
        </div>

        {/* Métricas */}
        <div className="lg:col-start-1 lg:row-start-3" data-id="element-248" data-mp="2yzsvvsa9ps0q">
          <dl className="mt-6 grid grid-cols-4 gap-x-2 border-t border-warm pt-3.5 sm:gap-x-4" data-id="element-249" data-mp="2yy805zc7w31a">
            {HERO_METRICS.map(metric => <div key={metric.label} className="text-center lg:text-left" data-id="element-250" data-mp="2tylmxpwe2msh">
                <dt className="sr-only" data-id="element-251" data-mp="19h2r6kuc7o5z">{metric.label}</dt>
                <dd data-id="element-252" data-mp="1e9vv56hzesh0">
                  <span className="block font-display text-[1.3rem] leading-none text-caramel sm:text-[1.8rem]" data-id="element-253" data-mp="1eaf9yecc50qt">
                    {metric.value}
                  </span>
                  <span className="mt-1 block font-sans text-[0.52rem] font-semibold leading-tight text-charcoal-mid sm:text-[0.64rem]" data-id="element-254" data-mp="14j165udcperv">
                    {metric.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </div>
      <figcaption className="mt-2.5 text-center font-sans text-[0.58rem] font-bold uppercase tracking-editorial text-charcoal-mid sm:text-[0.62rem]" data-id="element-255" data-mp="1x65f2afked8x">
              El resultado
            </figcaption><img src={STUFFED_IMAGE} alt="New York Cookie gruesa partida al medio con relleno cremoso y chocolate fundido a la vista." width={1200} height={900} fetchPriority="high" decoding="async" className="aspect-[16/10] w-full rounded-5xl object-cover shadow-bakery" data-id="element-256" data-mp="1nc53pqtowbrr" /></section>
    </div>;
}